<template>
  <b-container fluid id="app" class="ui container">
    <h2 class="mt-5">Event List</h2>
    <b-row class="mt-3">
      <b-col md="6" class="my-1">
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Type to Search"
            ></b-form-input>

            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-button @click="$router.push({name: 'CalendarForm'})" class="mr-1 mb-1">
          Add New Record
        </b-button>
      </b-col>

      <b-col md="12" class="my-1 text-left">
          <b-form-checkbox-group
            v-model="filterOn"
            class="mt-1"
          >
            <b-form-checkbox v-for="field in fields.slice(0,-1)" :key="field.key" :value="field.key"> 
              {{ field.label }} 
            </b-form-checkbox>
          </b-form-checkbox-group>
      </b-col>
    </b-row>

    <!-- Main table element -->
    <b-table striped hover outlined responsive
      id='main-table'
      ref="table"
      :items="calEventList"
      :fields="fields"
      :filter="filter"
      :filter-included-fields="filterOn"
      stacked="md"
      show-empty
      primary-key="id"
      :tbody-transition-props="transProps"
    >
      <!-- <template #cell(gradeRange)="data">
        {{ gradeList[data.item.low_grade] }} - {{ gradeList[data.item.high_grade] }} 
      </template> -->
      <template #cell(actions)="row">
        <!-- <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1 mb-1">
          Info modal
        </b-button> -->
        <b-button size="sm" @click="row.toggleDetails" class="mr-1 mb-1">
          {{ row.detailsShowing ? 'Hide' : 'Details' }} 
        </b-button>
        <b-button size="sm" @click="onEdit(row.item)" class="mr-1 mb-1">
          Edit
        </b-button>
        <b-button size="sm" @click="onDelete(row.item, row.index, $event.target)" variant="danger" class="mr-1 mb-1">
          Delete
        </b-button>
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <div v-for="field in fields.slice(0,-1)" :key="field.id">
                {{field.label}} : {{ row.item[field.key] }}
            </div>
          </ul>
        </b-card>
      </template>
    </b-table>

    <!-- Info modal -->
    <!-- <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal> -->
  </b-container>
</template>

<script>
import FieldsDef from "./FieldsDef.js";
import DropdownLists from "../../components/DropdownLists.json";
// import CalendarForm from "../CalendarForm.vue"
import { getEvent, getUser, deleteCalendarEvent } from '../../services/api.js';

export default {
  components: {
    // CalendarForm,
  },
  name: 'calEventList',
  data() {
    return {
      user: {},
      calEventList: [],
      fields: FieldsDef,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      deleteConfirmed: false,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      gradeList: DropdownLists.gradeList
    }
  },
  methods: {
    // info(item, index, button) {
    //   this.infoModal.title = `Row index: ${index}`
    //   this.infoModal.content = JSON.stringify(item, null, 2)
    //   this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    // },
    // resetInfoModal() {
    //   this.infoModal.title = ''
    //   this.infoModal.content = ''
    // },
    onDelete(item) {
      this.$bvModal.msgBoxConfirm(`Please confirm that you want to delete event: \n ${DropdownLists.eventList[item.event_type]}`, {
        title: 'Please Confirm',
        // buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(value => {
        this.deleteConfirmed = value
        if (value)
          this.deleteItem(item.id)
      })
      .catch(err => {
        // An error occurred
        console.log(err)
      })
    },
    async deleteItem(id) {
      let deleteResponse = await deleteCalendarEvent('id', id)
      if (deleteResponse.status != 204) {
        alert("Network Problem")
        throw new Error(deleteResponse.statusText);
      } else {
        this.updateEvents()
      }
    },
    onEdit(value) {
      this.$router.push({
        name: 'CalendarForm',
        params: { filledevent: value }
      })
    },
    async updateEvents() {
      let userResponse = await getUser()
      if (userResponse.status !== 200) {
        alert("Network Problem")
        throw new Error(userResponse.statusText);
      }
      this.user = userResponse.data

      let eventResponse = await getEvent('district', this.user.meta_info.code)
      if (eventResponse.statusText != 'OK') {
        alert("Network Problem")
        throw new Error(eventResponse.statusText);
      }
      eventResponse = eventResponse.data
      this.calEventList = eventResponse
    },
  },
  mounted() {
    this.updateEvents()
  },
}
</script>

<style>
#calEventList {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
table#main-table .flip-list-move {
  transition: transform 0.5s;
}
</style>
